import qs from "qs";

export default {
  stringify: qs.stringify,
  parse: function(queryStr, options) {
    return qs.parse(queryStr.trim().replace(/^(\?|&|#)/, ""), options);
  }
};



// WEBPACK FOOTER //
// ./src/utils/query-string.js